
export default {
  computed: {
    siteName () {
      return this.$store.state.siteName
    }
  }
}
